import { Vector3 } from '@babylonjs/core';
import { InputManager } from '../InputManager';
import { CameraController } from './CameraController';
import { ICharacterInput } from './Character';

export class PlayerInput implements ICharacterInput {
  constructor(
    private input: InputManager,
    private camera: CameraController
  ) {}

  getMovementInput(): number {
    if (this.input.moveLeft && !this.input.moveRight) return -1;
    if (this.input.moveRight && !this.input.moveLeft) return 1;
    return 0;
  }

  getVerticalInput(): number {
    return this.input.getVerticalInput();
  }

  isJumpPressed(): boolean {
    return this.input.jump;
  }

  isAttackPressed(): boolean {
    return this.input.action;
  }

  getCameraForward(): Vector3 {
    return this.camera.getCamera().getForwardRay().direction;
  }

  getCameraRight(): Vector3 {
    const fwd = this.camera.getCamera().getForwardRay().direction;
    return Vector3.Cross(Vector3.Up(), fwd).normalize();
  }
}
